import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import CalculatorPromo from "@/components/CalculatorPromo";
import Reviews from "@/components/Reviews";
import Zones from "@/components/Zones";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#FAFAFA] text-black">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <CalculatorPromo />
      <Reviews />
      <Zones />
      <Contact />
      <Footer />
    </div>
  );
}
